/* eslint react-hooks/exhaustive-deps: "warn" */


import cn from 'classnames';

import { Badge } from 'ui/atoms/Badge/Badge';
import { Section } from 'ui/molecules/Section/Section';

import styles from './McpToolsCatalogSection.module.scss';

type Tool = {
  tag: string;
  title: string;
  description: string;
  comingSoon?: boolean;
  size?: 'lg' | 'wide';
};

const TOOLS: Tool[] = [
  {
    tag: '[ search ]',
    title: 'Company lookup',
    description:
      'Resolve a name, number, VAT or website to a verified entity in any jurisdiction — the entry point every other tool chains from.',
    size: 'lg',
  },
  {
    tag: '[ verify ]',
    title: 'KYB verification',
    description: 'Confirm legal status, registration and identity straight from the source registry.',
  },
  {
    tag: '[ graph ]',
    title: 'UBO & ownership',
    description: 'Walk the shareholder tree to beneficial owners with percentages and control paths.',
  },
  {
    tag: '[ link ]',
    title: 'Corporate linkage',
    description: 'Parents, subsidiaries and the full group structure mapped across borders.',
    size: 'wide',
  },
  {
    tag: '[ finance ]',
    title: 'Financials',
    description: 'Filed accounts, turnover and key figures, normalised across markets.',
  },
  {
    tag: '[ screen ]',
    title: 'PEPs & sanctions',
    description: 'Screen entities and people against watchlists inside the same call.',
    comingSoon: true,
  },
  {
    tag: '[ people ]',
    title: 'Officers & directors',
    description: 'Current and historical officers, with reverse lookup by individual.',
  },
  {
    tag: '[ watch ]',
    title: 'Continuous monitoring',
    description: 'Flag status, ownership or filing changes the moment a registry updates.',
    size: 'wide',
  },
  {
    tag: '[ docs ]',
    title: 'Registry documents',
    description: 'Pull official filings and source documents behind every data point.',
    comingSoon: true,
  },
];

export const McpToolsCatalogSection = () => {
  return (
    <Section
      fullWidth
      title="Everything your agent needs to act on a company."
      description="Search, verify, map ownership, screen risk and monitor change — exposed as discrete tools your AI can chain on its own."
      className={styles.section}
    >
      <div className={styles.grid}>
        {TOOLS.map((tool) => (
          <div
            key={tool.title}
            className={cn(
              styles.tool,
              tool.size === 'lg' && styles.toolLg,
              tool.size === 'wide' && styles.toolWide,
            )}
          >
            <span className={styles.tag}>{tool.tag}</span>
            <h4 className={styles.title}>
              {tool.title}
              {tool.comingSoon && (
                <Badge variant="white" size="sm" className={styles.soon}>
                  Coming soon
                </Badge>
              )}
            </h4>
            <p className={styles.description}>{tool.description}</p>

            <span className={styles.arrow} aria-hidden="true">
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path
                  d="M2 8L8 2M8 2H3M8 2V7"
                  stroke="currentColor"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </div>
        ))}

        <div className={cn(styles.tool, styles.toolMore)}>
          <p className={styles.moreText}>
            + 13 more tools
            <strong>Prospecting, digital insights, enrichment & bank account verification</strong>
          </p>
        </div>
      </div>
    </Section>
  );
};
